export const enum PERMISSIONS_LIST {
  admin_invitation = 'admin_invitation',
  carriers_manage = 'carriers_manage',
  carriers_view = 'carriers_view',
  company_manage = 'company_manage',
  impersonate = 'impersonate',
  shipments_manage = 'shipments_manage',
  roles_view = 'roles_view',
  shipments_messages = 'shipments_messages',
  drivers_manage = 'drivers_manage',
  non_drivers_manage = 'non_drivers_manage',
  team_view = 'team_view',
  team_edit = 'team_edit',
  track_and_trace_view = 'track_and_trace_view',
  user_change_role = 'user_change_role',
  user_deactivation = 'user_deactivation',
  user_edit = 'user_edit',
  edit_companies = 'edit_companies',
  user_invitation = 'user_invitation',
  users_view = 'users_view',
  user_report_generation = 'user_report_generation',
  shippers_view = 'shippers_view',
  shippers_manage = 'shippers_manage',
  violation_approve = 'violation_approve',
  shipments_close = 'shipments_close',
  shipments_edit = 'shipments_edit',
  activity_log_view = 'activity_log_view',
  carrier_users_manage = 'carrier_users_manage',
  shipments_reopen = 'shipments_reopen',
  shipments_change_status_to_at_pickup = 'shipments_change_status_to_at_pickup',
  sentinel_device_control = 'sentinel_device_control',
  call_vessel_position = 'call_vessel_position',
  manage_assets_access = 'manage_assets_access',
  manage_event_reasons = 'manage_event_reasons',
  manage_manual_incident = 'manage_manual_incident',
  shipments_move_to_in_transit = 'shipments_move_to_in_transit',
  shipments_move_to_picked_up = 'shipments_move_to_picked_up',
  shipments_move_between_in_transit_and_delivery_states = 'shipments_move_between_in_transit_and_delivery_states',
  manage_asset_actions = 'manage_asset_actions',
  asset_manager_event_management = 'asset_manager_event_management',
  asset_dashboard = 'asset_dashboard',
  logistics_dashboard = 'logistics_dashboard',
  security_dashboard = 'security_dashboard',
  shipment_insights = 'shipment_insights',
  command_center_dashboard = 'command_center_dashboard',
  personalize_dashboard_layouts = 'personalize_dashboard_layouts',
  create_workflow = 'create_workflow',
  edit_workflow = 'edit_workflow',
  activate_deactivate_workflow = 'activate_deactivate_workflow',
  edit_risk_events = 'edit_risk_events',
  hide_display_dashboard_widgets = 'hide_display_dashboard_widgets',
  deactivate_companies = 'deactivate_companies',
  edit_countries = 'edit_countries',
  chain_of_custody_power_bi_report_access = 'chain_of_custody_power_bi_report_access',
  shipment_temperature_power_bi_report_access = 'shipment_temperature_power_bi_report_access',
  bulk_update_shipments_status = 'bulk_update_shipments_status',
  shipments_hard_reset = 'shipments_hard_reset',
  manage_risk_score_templates = 'manage_risk_score_templates',
  //global access
  sentinel_access = 'sentinel_access',
  reports_access = 'reports_access',
  simpl_access = 'simpl_access',
  device_management_access = 'device_management_access',
  le_connect_access = 'le_connect_access',
  admin_page_access = 'admin_page_access',
  company_management_page_access = 'company_management_page_access',
  equipment_management_access = 'equipment_management_access',
  global_custom_fields = 'global_custom_fields',
  view_user_management = 'view_user_management',
  user_setup = 'user_setup',
  share_user_to_company = 'share_user_to_company',
  share_user_to_portal = 'share_user_to_portal',
  share_company_to_portal = 'share_company_to_portal',
  remove_employee_associations = 'remove_employee_associations',
  access_escalation_templates = 'access_escalation_templates',
  access_riskscore_rules = 'access_riskscore_rules',
  manage_customers = 'manage_customers',
  //locations
  lm_location_manage_ports = 'lm_location_manage_ports',
  lm_location_additional_attributes = 'lm_location_additional_attributes',
  lm_location_advanced_import_export = 'lm_location_advanced_import_export',
  lm_location_manage_standards = 'lm_location_manage_standards',
  lm_location_manage_zones = 'lm_location_manage_zones',
  lm_location_manage_geofence = 'lm_location_manage_geofence',
  lm_location_view = 'lm_location_view',
  lm_location_clone_zones = 'lm_location_clone_zones',
  disruption_zone_manage = 'disruption_zone_manage',
  //dashboard KPIs
  active_shipments_in_redzone_dashboard_widget = 'active_shipments_in_redzone_dashboard_widget',
  active_shipments_dashboard_widget = 'active_shipments_dashboard_widget',
  violations_dashboard_widget = 'violations_dashboard_widget',
  on_time_performance_dashboard_widget = 'on_time_performance_dashboard_widget',
  at_risk_eta_status_dashboard_widget = 'at_risk_eta_status_dashboard_widget',
  shipments_by_status_dashboard_widget = 'shipments_by_status_dashboard_widget',
  daily_shipments_status_dashboard_widget = 'daily_shipments_status_dashboard_widget',
  completing_today_dashboard_widget = 'completing_today_dashboard_widget',
  eta_at_risk_map_dashboard_widget = 'eta_at_risk_map_dashboard_widget',
  non_compliance_dashboard_widget = 'non_compliance_dashboard_widget',
  lost_shipments_dashboard_widget = 'lost_shipments_dashboard_widget',
  early_eta_status_dashboard_widget = 'early_eta_status_dashboard_widget',
  ontime_eta_status_dashboard_widget = 'ontime_eta_status_dashboard_widget',
  late_eta_status_dashboard_widget = 'late_eta_status_dashboard_widget',
  map_incidents_dashboard_widget = 'map_incidents_dashboard_widget',
  inbounds_dashboard_widget = 'inbounds_dashboard_widget',
  outbounds_dashboard_widget = 'outbounds_dashboard_widget',
  user_performance_dashboard_widget = 'user_performance_dashboard_widget',
  risk_events_performance_dashboard_widget = 'risk_events_performance_dashboard_widget',
  recovered_incidents_dashboard_widget = 'recovered_incidents_dashboard_widget',
  shipment_mode_dashboard_widget = 'shipment_mode_dashboard_widget',
  carrier_compliance_by_risk_dashboard_widget = 'carrier_compliance_by_risk_dashboard_widget',
  high_risk_by_event_type_dashboard_widget = 'high_risk_by_event_type_dashboard_widget',
  no_eta_status_dashboard_widget = 'no_eta_status_dashboard_widget',
  time_spent_in_quality_excursion_dashboard_widget = 'time_spent_in_quality_excursion_dashboard_widget',
  quality_excursion_incidents_response_time_dashboard_widget = 'quality_excursion_incidents_response_time_dashboard_widget',
  quality_risk_status_dashboard_widget = 'quality_risk_status_dashboard_widget',
  quality_regulatory_heat_map_dashboard_widget = 'quality_regulatory_heat_map_dashboard_widget',
  quality_risk_score_dashboard_widget = 'quality_risk_score_dashboard_widget',
  dashboard_save = 'dashboard_save',
  dashboard_share = 'dashboard_share',
  view_routes = 'view_routes',
  add_routes = 'add_routes',
  activate_deactivate_routes = 'activate_deactivate_routes',
  co2e_dashboard_widget = 'co2e_dashboard_widget',
  create_manual_events = 'create_manual_events',
  bulk_route_actions = 'bulk_route_actions',
  contact_department_filtering = 'contact_department_filtering',
  view_power_bi_reports = 'view_power_bi_reports',
  manage_power_bi_workspaces = 'manage_power_bi_workspaces',
  manage_power_bi_reports = 'manage_power_bi_reports',
  manage_companies_power_bi_reports = 'manage_companies_power_bi_reports',
  manage_companies_custom_power_bi_reports = 'manage_companies_custom_power_bi_reports',
  edit_carrier_watchlist = 'edit_carrier_watchlist',
  shipment_temperature_alerts_dashboard_widget = 'shipment_temperature_alerts_dashboard_widget',
  edit_user_portal_filter = 'edit_user_portal_filter',
  device_profile_setup = 'device_profile_setup',
  portal_sso_settings_edit = 'portal_sso_settings_edit',
  contacts_page_access = 'contacts_page_access',
  manage_location_contacts = 'manage_location_contacts',
  fraudwatch_access = 'fraudwatch_access',
  device_management_debug = 'device_management_debug',
  reminder_action = 'reminder_action',
  device_management_create = 'device_management_create',
  device_management_activate_deactivate = 'device_management_activate_deactivate',
  device_management_edit = 'device_management_edit',
  device_management_edit_model = 'device_management_edit_model',
  device_management_gateways = 'device_management_gateways',
  quality_excursion_by_time_period_dashboard_widget = 'quality_excursion_by_time_period_dashboard_widget',
  remove_shipment_attachments = 'remove_shipment_attachments',
  view_qrcs = 'view_qrcs',
  fraudwatch_indicate_known_bad_actors = 'fraudwatch_indicate_known_bad_actors',
  send_escalation_emails = 'send_escalation_emails',
  risk_gpt_investigation = 'risk_gpt_investigation',
  risk_gpt_chat_tab = 'risk_gpt_chat_tab',
  sc_go_create_shipment = 'shipment_connect_go_create_shipment',
  sc_go_pickup_shipment = 'shipment_connect_go_pickup_shipment',
  ebol_access = 'ebol_management_access',
  handling_units_profiles_access = 'handling_units_profiles_access',
  edit_non_admin_user_portal_filter = 'edit_non_admin_user_portal_filter',
  asset_manager_assets_transfer = 'asset_manager_assets_transfer',
  handling_units_packing_list_access = 'handling_units_packing_list_access',
  quality_manager_access = 'quality_manager_access',
  shipment_ref_number_patterns_access = 'shipment_ref_number_patterns_access',
  notification_center_events_access = 'notification_center_events_access',
  notification_center_general_email_access = 'notification_center_general_email_access',
  notification_center_photo_verifications_access = 'notification_center_photo_verifications_access',
  notification_center_sms_access = 'notification_center_sms_access',
  notification_center_calls_access = 'notification_center_calls_access',
  device_management_export_iot_device_data = 'device_management_export_iot_device_data',
  in_app_calling = 'in_app_calling',
  in_app_texting = 'in_app_texting',
  healthcare_view_access = 'healthcare_view_access',
  healthcare_manage_medical_devices = 'healthcare_manage_medical_devices',
  healthcare_manage_appointments = 'healthcare_manage_appointments',
  healthcare_assign_medical_devices_to_appointments = 'healthcare_assign_medical_devices_to_appointments',
  healthcare_manage_medtech_attributes = 'healthcare_manage_medtech_attributes',
  carrier_companies_merge = 'carrier_companies_merge',
  view_consumable_items = 'view_consumable_items',
  manage_consumable_items = 'manage_consumable_items',
  view_consumable_inventory = 'view_consumable_inventory',
  manage_consumable_inventory = 'manage_consumable_inventory',
  view_consumable_inventory_network = 'view_consumable_inventory_network',
  fraudwatch_risks_access = 'fraudwatch_risks_access',
  fraudwatch_authorization_access = 'fraudwatch_authorization_access',
  create_new_carriers = 'create_new_carriers',
  quality_review_page_access = 'quality_review_page_access',
  quality_review_accept_reject_shipment = 'quality_review_accept_reject_shipment',
  quality_review_status_update = 'quality_review_status_update',
  rm_view_invalid_events = 'rm_view_invalid_events',
  enable_overhaul_contracted_escorts = 'enable_overhaul_contracted_escorts',
}

export const PERMISSIONS_LABELS: { [key in PERMISSIONS_LIST]: string } = {
  [PERMISSIONS_LIST.admin_invitation]: 'permission_admin_invitation',
  [PERMISSIONS_LIST.carriers_manage]: 'permission_carriers_manage',
  [PERMISSIONS_LIST.carriers_view]: 'permission_carriers_view',
  [PERMISSIONS_LIST.company_manage]: 'permission_company_manage',
  [PERMISSIONS_LIST.impersonate]: 'permission_impersonate',
  [PERMISSIONS_LIST.shipments_manage]: 'permission_shipments_manage',
  [PERMISSIONS_LIST.roles_view]: 'permission_roles_view',
  [PERMISSIONS_LIST.shipments_messages]: 'permission_shipments_messages',
  [PERMISSIONS_LIST.drivers_manage]: 'permission_drivers_manage',
  [PERMISSIONS_LIST.non_drivers_manage]: 'permission_non_drivers_manage',
  [PERMISSIONS_LIST.team_view]: 'permission_team_view',
  [PERMISSIONS_LIST.team_edit]: 'permission_team_edit',
  [PERMISSIONS_LIST.track_and_trace_view]: 'permission_track_and_trace_view',
  [PERMISSIONS_LIST.user_change_role]: 'permission_user_change_role',
  [PERMISSIONS_LIST.user_deactivation]: 'permission_user_deactivation',
  [PERMISSIONS_LIST.user_edit]: 'permission_user_edit',
  [PERMISSIONS_LIST.edit_companies]: 'permission_edit_companies',
  [PERMISSIONS_LIST.user_invitation]: 'permission_user_invitation',
  [PERMISSIONS_LIST.users_view]: 'permission_users_view',
  [PERMISSIONS_LIST.user_report_generation]: 'permission_user_report_generation',
  [PERMISSIONS_LIST.shippers_view]: 'permission_shippers_view',
  [PERMISSIONS_LIST.shippers_manage]: 'permission_shippers_manage',
  [PERMISSIONS_LIST.violation_approve]: 'permission_violation_approve',
  [PERMISSIONS_LIST.shipments_close]: 'permission_shipments_close',
  [PERMISSIONS_LIST.shipments_edit]: 'permission_shipments_edit',
  [PERMISSIONS_LIST.activity_log_view]: 'permission_activity_log_view',
  [PERMISSIONS_LIST.carrier_users_manage]: 'permission_carrier_users_manage',
  [PERMISSIONS_LIST.shipments_reopen]: 'permission_shipments_reopen',
  [PERMISSIONS_LIST.shipments_change_status_to_at_pickup]: 'permission_shipments_change_status_to_at_pickup',
  [PERMISSIONS_LIST.sentinel_device_control]: 'permission_sentinel_device_control',
  [PERMISSIONS_LIST.call_vessel_position]: 'permission_call_vessel_position',
  [PERMISSIONS_LIST.manage_assets_access]: 'permission_manage_assets_access',
  [PERMISSIONS_LIST.manage_event_reasons]: 'permission_manage_event_reasons',
  [PERMISSIONS_LIST.manage_manual_incident]: 'permission_manage_manual_incident',
  [PERMISSIONS_LIST.shipments_move_to_in_transit]: 'permission_shipments_move_to_in_transit',
  [PERMISSIONS_LIST.shipments_move_to_picked_up]: 'permission_shipments_move_to_picked_up',
  [PERMISSIONS_LIST.shipments_move_between_in_transit_and_delivery_states]: 'permission_shipments_move_between_in_transit_and_delivery_states',
  [PERMISSIONS_LIST.manage_asset_actions]: 'permission_manage_asset_actions',
  [PERMISSIONS_LIST.asset_manager_event_management]: 'permission_asset_manager_event_management',
  [PERMISSIONS_LIST.asset_dashboard]: 'permission_asset_dashboard',
  [PERMISSIONS_LIST.logistics_dashboard]: 'permission_logistics_dashboard',
  [PERMISSIONS_LIST.security_dashboard]: 'permission_security_dashboard',
  [PERMISSIONS_LIST.shipment_insights]: 'permission_shipment_insights',
  [PERMISSIONS_LIST.command_center_dashboard]: 'permission_command_center_dashboard',
  [PERMISSIONS_LIST.personalize_dashboard_layouts]: 'permission_personalize_dashboard_layouts',
  [PERMISSIONS_LIST.create_workflow]: 'permission_create_workflow',
  [PERMISSIONS_LIST.edit_workflow]: 'permission_edit_workflow',
  [PERMISSIONS_LIST.activate_deactivate_workflow]: 'permission_activate_deactivate_workflow',
  [PERMISSIONS_LIST.edit_risk_events]: 'permission_edit_risk_events',
  [PERMISSIONS_LIST.hide_display_dashboard_widgets]: 'permission_hide_display_dashboard_widgets',
  [PERMISSIONS_LIST.deactivate_companies]: 'permission_deactivate_companies',
  [PERMISSIONS_LIST.edit_countries]: 'permission_edit_countries',
  [PERMISSIONS_LIST.shipment_temperature_power_bi_report_access]: 'permission_shipment_temperature_report_access',
  [PERMISSIONS_LIST.chain_of_custody_power_bi_report_access]: 'permission_chain_of_custody_power_bi',
  [PERMISSIONS_LIST.manage_location_contacts]: 'permission_manage_location_contacts',
  [PERMISSIONS_LIST.manage_risk_score_templates]: 'permission_manage_risk_score_templates',
  //global access
  [PERMISSIONS_LIST.sentinel_access]: 'permission_sentinel_access',
  [PERMISSIONS_LIST.reports_access]: 'permission_reports_access',
  [PERMISSIONS_LIST.simpl_access]: 'permission_simpl_access',
  [PERMISSIONS_LIST.device_management_access]: 'permission_device_management_access',
  [PERMISSIONS_LIST.le_connect_access]: 'permission_le_connect_access',
  [PERMISSIONS_LIST.admin_page_access]: 'permission_admin_page_access',
  [PERMISSIONS_LIST.company_management_page_access]: 'permission_company_management_page_access',
  [PERMISSIONS_LIST.equipment_management_access]: 'permission_equipment_management_access',
  [PERMISSIONS_LIST.global_custom_fields]: 'permission_global_custom_fields',
  [PERMISSIONS_LIST.view_user_management]: 'permission_view_user_management',
  [PERMISSIONS_LIST.user_setup]: 'permission_userSetup',
  [PERMISSIONS_LIST.share_user_to_company]: 'permission_share_user_to_company',
  [PERMISSIONS_LIST.share_user_to_portal]: 'permission_share_user_to_portal',
  [PERMISSIONS_LIST.share_company_to_portal]: 'permission_share_company_to_portal',
  [PERMISSIONS_LIST.remove_employee_associations]: 'permission_remove_employee_associations',
  [PERMISSIONS_LIST.access_escalation_templates]: 'permission_access_escalation_templates',
  [PERMISSIONS_LIST.access_riskscore_rules]: 'permission_access_riskscore_rules',
  [PERMISSIONS_LIST.bulk_update_shipments_status]: 'permission_bulk_shipments_close',
  [PERMISSIONS_LIST.shipments_hard_reset]: 'permission_shipmentsHardReset',
  [PERMISSIONS_LIST.manage_customers]: 'permission_manage_customers',
  //locations
  [PERMISSIONS_LIST.lm_location_manage_ports]: 'permission_lm_location_manage_ports',
  [PERMISSIONS_LIST.lm_location_additional_attributes]: 'permission_lm_location_additional_attributes',
  [PERMISSIONS_LIST.lm_location_advanced_import_export]: 'permission_lm_location_advanced_import_export',
  [PERMISSIONS_LIST.lm_location_manage_standards]: 'permission_lm_location_manage_standards',
  [PERMISSIONS_LIST.lm_location_manage_zones]: 'permission_lm_location_manage_zones',
  [PERMISSIONS_LIST.lm_location_manage_geofence]: 'permission_lm_location_manage_geofence',
  [PERMISSIONS_LIST.lm_location_view]: 'permission_lm_location_view',
  [PERMISSIONS_LIST.lm_location_clone_zones]: 'permission_lm_location_clone_zones',
  [PERMISSIONS_LIST.disruption_zone_manage]: 'permission_disruption_zone_manage',
  //dashboard KPIs
  [PERMISSIONS_LIST.active_shipments_in_redzone_dashboard_widget]: 'permission_active_shipments_in_redzone_dashboard_widget',
  [PERMISSIONS_LIST.active_shipments_dashboard_widget]: 'permission_active_shipments_dashboard_widget',
  [PERMISSIONS_LIST.violations_dashboard_widget]: 'permission_violations_dashboard_widget',
  [PERMISSIONS_LIST.on_time_performance_dashboard_widget]: 'permission_on_time_performance_dashboard_widget',
  [PERMISSIONS_LIST.at_risk_eta_status_dashboard_widget]: 'permission_at_risk_eta_status_dashboard_widget',
  [PERMISSIONS_LIST.shipments_by_status_dashboard_widget]: 'permission_shipments_by_status_dashboard_widget',
  [PERMISSIONS_LIST.daily_shipments_status_dashboard_widget]: 'permission_daily_shipments_status_dashboard_widget',
  [PERMISSIONS_LIST.completing_today_dashboard_widget]: 'permission_completing_today_dashboard_widget',
  [PERMISSIONS_LIST.eta_at_risk_map_dashboard_widget]: 'permission_eta_at_risk_map_dashboard_widget',
  [PERMISSIONS_LIST.non_compliance_dashboard_widget]: 'permission_non_compliance_dashboard_widget',
  [PERMISSIONS_LIST.lost_shipments_dashboard_widget]: 'permission_lost_shipments_dashboard_widget',
  [PERMISSIONS_LIST.early_eta_status_dashboard_widget]: 'permission_early_eta_status_dashboard_widget',
  [PERMISSIONS_LIST.ontime_eta_status_dashboard_widget]: 'permission_ontime_eta_status_dashboard_widget',
  [PERMISSIONS_LIST.late_eta_status_dashboard_widget]: 'permission_late_eta_status_dashboard_widget',
  [PERMISSIONS_LIST.map_incidents_dashboard_widget]: 'permission_map_incidents_dashboard_widget',
  [PERMISSIONS_LIST.inbounds_dashboard_widget]: 'permission_inbounds_dashboard_widget',
  [PERMISSIONS_LIST.outbounds_dashboard_widget]: 'permission_outbounds_dashboard_widget',
  [PERMISSIONS_LIST.user_performance_dashboard_widget]: 'permission_user_performance_dashboard_widget',
  [PERMISSIONS_LIST.risk_events_performance_dashboard_widget]: 'permission_riskEventsPerformanceDashboardWidget',
  [PERMISSIONS_LIST.recovered_incidents_dashboard_widget]: 'permission_recovered_incidents_dashboard_widget',
  [PERMISSIONS_LIST.shipment_mode_dashboard_widget]: 'permission_shipment_mode_dashboard_widget',
  [PERMISSIONS_LIST.carrier_compliance_by_risk_dashboard_widget]: 'permission_carrier_compliance_by_risk_dashboard_widget',
  [PERMISSIONS_LIST.high_risk_by_event_type_dashboard_widget]: 'permission_high_risk_by_event_type_dashboard_widget',
  [PERMISSIONS_LIST.no_eta_status_dashboard_widget]: 'permission_no_eta_status_dashboard_widget',
  [PERMISSIONS_LIST.dashboard_save]: 'permission_dashboard_save',
  [PERMISSIONS_LIST.dashboard_share]: 'permission_dashboard_share',
  [PERMISSIONS_LIST.view_routes]: 'permission_view_routes',
  [PERMISSIONS_LIST.add_routes]: 'permission_add_routes',
  [PERMISSIONS_LIST.activate_deactivate_routes]: 'permission_activate_deactivate_routes',
  [PERMISSIONS_LIST.co2e_dashboard_widget]: 'permission_co2e_dashboard_widget',
  [PERMISSIONS_LIST.create_manual_events]: 'permission_create_manual_events',
  [PERMISSIONS_LIST.bulk_route_actions]: 'permission_bulk_route_actions',
  [PERMISSIONS_LIST.contact_department_filtering]: 'permission_contact_department_filtering',
  [PERMISSIONS_LIST.manage_power_bi_workspaces]: 'permission_manage_power_bi_workspaces',
  [PERMISSIONS_LIST.view_power_bi_reports]: 'permission_viewPowerBiReports',
  [PERMISSIONS_LIST.manage_companies_power_bi_reports]: 'permission_manageCompaniesPowerBiReports',
  [PERMISSIONS_LIST.manage_companies_custom_power_bi_reports]: 'permission_manageCompaniesCustomPowerBiReports',
  [PERMISSIONS_LIST.manage_power_bi_reports]: 'permission_managePowerBiReports',
  [PERMISSIONS_LIST.edit_carrier_watchlist]: 'permission_edit_carrier_watchlist',
  [PERMISSIONS_LIST.shipment_temperature_alerts_dashboard_widget]: 'permission_shipment_temperature_alerts_dashboard_widget',
  [PERMISSIONS_LIST.edit_user_portal_filter]: 'permission_editUserPortalFilter',
  [PERMISSIONS_LIST.device_profile_setup]: 'permission_deviceProfileSetup',
  [PERMISSIONS_LIST.portal_sso_settings_edit]: 'permission_portalSsoSettingsEdit',
  [PERMISSIONS_LIST.contacts_page_access]: 'permission_contactsPageAccess',
  [PERMISSIONS_LIST.fraudwatch_access]: 'permission_fraudwatchDashboardAccess',
  [PERMISSIONS_LIST.device_management_debug]: 'permission_deviceManagementDebug',
  [PERMISSIONS_LIST.reminder_action]: 'permission_reminderAction',
  [PERMISSIONS_LIST.time_spent_in_quality_excursion_dashboard_widget]: 'permission_time_spent_in_quality_excursion_dashboard_widget',
  [PERMISSIONS_LIST.quality_excursion_incidents_response_time_dashboard_widget]: 'permission_qualityExcursionIncidents',
  [PERMISSIONS_LIST.quality_risk_status_dashboard_widget]: 'permission_qualityRiskStatusDashboardWidget',
  [PERMISSIONS_LIST.quality_regulatory_heat_map_dashboard_widget]: 'permission_qualityRegulatoryHeatMapDashboardWidget',
  [PERMISSIONS_LIST.device_management_create]: 'permission_deviceManagementCreate',
  [PERMISSIONS_LIST.device_management_activate_deactivate]: 'permission_deviceManagementActivateDeactivate',
  [PERMISSIONS_LIST.device_management_edit]: 'permission_deviceManagementEdit',
  [PERMISSIONS_LIST.device_management_edit_model]: 'permission_deviceManagementEditModel',
  [PERMISSIONS_LIST.device_management_gateways]: 'permission_deviceManagementGateways',
  [PERMISSIONS_LIST.quality_risk_score_dashboard_widget]: 'permission_qualityRiskScoreDashboardWidget',
  [PERMISSIONS_LIST.quality_excursion_by_time_period_dashboard_widget]: 'permission_qualityExcursionByTimeDashboardWidget',
  [PERMISSIONS_LIST.remove_shipment_attachments]: 'permission_removeShipmentAttachment',
  [PERMISSIONS_LIST.view_qrcs]: 'permission_viewQRCs',
  [PERMISSIONS_LIST.fraudwatch_indicate_known_bad_actors]: 'permission_indicateKnownBadActors',
  [PERMISSIONS_LIST.send_escalation_emails]: 'permission_sendEscalationEmails',
  [PERMISSIONS_LIST.risk_gpt_investigation]: 'permission_riskGptInvestigation',
  [PERMISSIONS_LIST.risk_gpt_chat_tab]: 'permission_riskGptChatTab',
  [PERMISSIONS_LIST.sc_go_create_shipment]: 'permission_scGoCreateShipment',
  [PERMISSIONS_LIST.sc_go_pickup_shipment]: 'permission_scGoPickupShipment',
  [PERMISSIONS_LIST.ebol_access]: 'permission_ebolAccess',
  [PERMISSIONS_LIST.handling_units_profiles_access]: 'permission_handlingUnitsProfilesAccess',
  [PERMISSIONS_LIST.edit_non_admin_user_portal_filter]: 'permission_editNonAdminUserPortalFilter',
  [PERMISSIONS_LIST.asset_manager_assets_transfer]: 'permission_assetManagerAssetsTransfer',
  [PERMISSIONS_LIST.handling_units_packing_list_access]: 'permission_handlingUnitsPackingListAccess',
  [PERMISSIONS_LIST.quality_manager_access]: 'permission_qualityManagerAccess',
  [PERMISSIONS_LIST.shipment_ref_number_patterns_access]: 'permission_shipmentIdSettingsAccess',
  [PERMISSIONS_LIST.notification_center_events_access]: 'permission_eventBasedNotificationCenter',
  [PERMISSIONS_LIST.notification_center_general_email_access]: 'permission_generalEmailsSupportNotificationCenter',
  [PERMISSIONS_LIST.notification_center_photo_verifications_access]: 'permission_notificationCenterPhotoVerificationsAccess',
  [PERMISSIONS_LIST.notification_center_sms_access]: 'permission_textMessagesNotificationCenter',
  [PERMISSIONS_LIST.notification_center_calls_access]: 'permission_callBasedNotificationCenter',
  [PERMISSIONS_LIST.device_management_export_iot_device_data]: 'permission_deviceManagementExportDeviceData',
  [PERMISSIONS_LIST.in_app_calling]: 'permission_outboundCalling',
  [PERMISSIONS_LIST.in_app_texting]: 'permission_outboundTexting',
  [PERMISSIONS_LIST.healthcare_view_access]: 'permission_healthcareViewAccess',
  [PERMISSIONS_LIST.healthcare_manage_medical_devices]: 'permission_healthcareManageMedicalDevices',
  [PERMISSIONS_LIST.healthcare_manage_appointments]: 'permission_healthcareManageAppointments',
  [PERMISSIONS_LIST.healthcare_assign_medical_devices_to_appointments]: 'permission_healthcareAssignMedicalDevicesToAppointments',
  [PERMISSIONS_LIST.healthcare_manage_medtech_attributes]: 'permission_healthcareManageMedtechAttributes',
  [PERMISSIONS_LIST.carrier_companies_merge]: 'permission_mergeCarriers',
  [PERMISSIONS_LIST.view_consumable_items]: 'permission_viewConsumableItems',
  [PERMISSIONS_LIST.manage_consumable_items]: 'permission_manageConsumableItems',
  [PERMISSIONS_LIST.view_consumable_inventory]: 'permission_viewInventoryItems',
  [PERMISSIONS_LIST.manage_consumable_inventory]: 'permission_manageInventoryItems',
  [PERMISSIONS_LIST.view_consumable_inventory_network]: 'permission_viewConsumableInventoryNetwork',
  [PERMISSIONS_LIST.fraudwatch_risks_access]: 'permission_fraudwatchRisksAccess',
  [PERMISSIONS_LIST.fraudwatch_authorization_access]: 'permission_fraudwatchAuthorizationAccess',
  [PERMISSIONS_LIST.create_new_carriers]: 'permission_createNewCarriers',
  [PERMISSIONS_LIST.quality_review_page_access]: 'permission_qualityReviewPageAccess',
  [PERMISSIONS_LIST.quality_review_accept_reject_shipment]: 'permission_qualityReviewAcceptRejectShipment',
  [PERMISSIONS_LIST.quality_review_status_update]: 'permission_qualityReviewStatusUpdate',
  [PERMISSIONS_LIST.rm_view_invalid_events]: 'permission_rmViewInvalidEvents',
  [PERMISSIONS_LIST.enable_overhaul_contracted_escorts]: 'permission_enableEscortConnect',
};

export default PERMISSIONS_LIST;
